import clsx from "clsx";
import { ChangeEvent, FC, useEffect, useState } from "react";
import { PulseLoader } from "react-spinners";
import { ArrowSmallDownIcon } from "../../../assets";
import {
  Button,
  CheckBox,
  JobPostingItem,
  PageItem,
  RequestItem,
  SearchInput,
} from "../../../components";
import { IJob } from "../../../models";
import { getJobs } from "../../../services/job.service";
import styles from "./styles.module.scss";
import PaginationButtons from "../../../components/PaginationButtons";
const limit = 20;
const JobPosting: FC = (): JSX.Element => {
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [pagesCount, setPagesCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [jobs, setJobs] = useState<IJob[]>([]);
  const [sort, setSort] = useState<number>(-1);

  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onGetJobs = async (
    page: number = 1,
    limit: number,
    search: string = ""
  ) => {
    try {
      setIsLoading(true);

      const { data } = await getJobs(page, limit, search, sort);
      if (data?.success) {
        setPagesCount(Math.ceil(data?.count / limit));
        setJobs(data?.jobs);
        setPage(page);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (search) {
        onGetJobs(1, limit, search);
      }
    }, 400);

    return () => clearTimeout(timeout);
  }, [search, sort]);

  useEffect(() => {
    if (!search) {
      onGetJobs(1, limit, search);
    }
  }, [search, sort]);

  return (
    <>
      <div className={styles.wrapper}>
        <header className={styles.header}>
          <h4 className={styles.title}>Job Postings</h4>
        </header>
        <section className={styles.contentContainer}>
          <div className={styles.searchContainer}>
            <SearchInput
              placeholder="Search"
              value={search}
              onChange={onChangeSearch}
            />
          </div>
          <div className={styles.sectionHeader}>
            <CheckBox isChecked={false} setIsChecked={() => {}} />
            <div className={styles.jobBlock}>
              <p>Job posting title</p> <ArrowSmallDownIcon />
            </div>
            <div className={styles.companyBlock}>
              <p>Company</p> <ArrowSmallDownIcon />
            </div>

            <div
              onClick={() => setSort((prev) => (prev === 1 ? -1 : 1))}
              className={clsx(styles.dateBlock, {
                [styles.dateBlockActive]: sort === 1,
              })}
            >
              <p>Request date</p> <ArrowSmallDownIcon />
            </div>
          </div>
          <div className={styles.reportsContainer}>
            {isLoading && (
              <div className={styles.loaderWrapper}>
                <PulseLoader color={"#7D4AFB"} />
              </div>
            )}
            {!isLoading &&
              jobs.map((item, index) => {
                return (
                  <JobPostingItem
                    key={item.id}
                    item={item}
                    onGetJobs={onGetJobs}
                  />
                );
              })}
            {!isLoading && jobs?.length === 0 && (
              <div className={styles.emptyTitle}>There are no job postings</div>
            )}
          </div>
          <PaginationButtons
            pagesCount={pagesCount}
            page={page}
            onPress={(index) => onGetJobs(index, limit, search)}
          />
        </section>
      </div>
    </>
  );
};

export default JobPosting;
